import { useMemo } from "react"
import { getGramFromIngredients } from "model/food/utils/getPayloads/gram"

const useGramFromIngredients = (food?: {
  ingredients: { gram: null | number }[]
}) => {
  return useMemo(() => {
    if (!food) return null
    return getGramFromIngredients(food.ingredients ?? [])
  }, [food])
}

export default useGramFromIngredients
